import React from 'react'

const AboutInfo = () => {
  return (
    <>
      <div className="col-lg-12">
  {/* About Facility List Start */}
  <div className="about-facility-list">
    {/* About Facility Item Start */}
    <div className="about-facility-item wow fadeInUp">
      <div className="icon-box">
        <img src="images/icon-about-facility-1.svg" alt="" />
      </div>
      <div className="about-facility-content">
        <h3>reasonable prices</h3>
        <p>
          We produce furniture to fulfill needs of all people and offer it at
          affordable prices.
        </p>
      </div>
    </div>
    {/* About Facility Item End */}
    {/* About Facility Item Start */}
    <div className="about-facility-item wow fadeInUp" data-wow-delay="0.2s">
      <div className="icon-box">
        <img src="images/icon-about-facility-2.svg" alt="" />
      </div>
      <div className="about-facility-content">
        <h3>exclusive design</h3>
        <p>
          Mixture of imagination, experience and professionalism is the secret
          of our design!
        </p>
      </div>
    </div>
    {/* About Facility Item End */}
    {/* About Facility Item Start */}
    <div className="about-facility-item wow fadeInUp" data-wow-delay="0.4s">
      <div className="icon-box">
        <img src="images/icon-about-facility-2.svg" alt="" />
      </div>
      <div className="about-facility-content">
        <h3>professional team</h3>
        <p>
          We are proud of our amicable, professional and always developing team!
        </p>
      </div>
    </div>
    {/* About Facility Item End */}
  </div>
  {/* About Facility List End */}
</div>

    </>
  )
}

export default AboutInfo
